import React from "react";
import { Crown, Star, Rocket, User, Award } from "lucide-react";

const GROUP_META = {
  mdc_winner: { icon: Crown, tone: "gold", label: "MDC Winner" },
  pc_winner: { icon: Award, tone: "gold", label: "PC Winner" },
  sprint_to_pc: { icon: Rocket, tone: "mint", label: "Sprint to PC" },
  non_pc: { icon: User, tone: "neutral", label: "Non-PC Attendee" },
  leadership: { icon: Star, tone: "lavender", label: "Leadership" },
};

const LIGHT = {
  gold: "bg-[hsl(var(--pc-gold)/0.16)] border-[hsl(var(--pc-gold)/0.45)] text-[hsl(38_50%_34%)]",
  mint: "bg-[hsl(var(--secondary)/0.12)] border-[hsl(var(--secondary)/0.35)] text-[hsl(var(--secondary))]",
  lavender: "bg-[hsl(var(--lavender)/0.5)] border-[hsl(var(--lavender))] text-[hsl(276_40%_40%)]",
  neutral: "bg-[hsl(var(--muted))] border-[hsl(var(--border))] text-[hsl(var(--muted-foreground))]",
};

const DARK = {
  gold: "bg-[hsl(var(--pc-gold)/0.18)] border-[hsl(var(--pc-gold)/0.5)] text-[hsl(var(--pc-gold))]",
  mint: "bg-[hsl(var(--mint)/0.14)] border-[hsl(var(--mint)/0.4)] text-[hsl(var(--mint))]",
  lavender: "bg-[hsl(var(--lavender)/0.14)] border-[hsl(var(--lavender)/0.4)] text-[hsl(var(--lavender))]",
  neutral: "bg-[hsl(var(--pc-cream)/0.1)] border-[hsl(var(--pc-line))] text-[hsl(var(--pc-cream-dim))]",
};

export function GroupBadge({ groupId, groupName, size = "sm", withIcon = true, dark = false }) {
  const meta = GROUP_META[groupId] || { icon: User, tone: "neutral" };
  const Icon = meta.icon;
  const cls = (dark ? DARK : LIGHT)[meta.tone];
  const sizes = size === "xs" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1";
  return (
    <span
      data-testid="group-badge"
      className={`inline-flex items-center gap-1 rounded-full border font-semibold tracking-wide ${cls} ${sizes}`}
    >
      {withIcon && <Icon className="h-3 w-3" strokeWidth={2.2} />}
      {groupName || meta.label}
    </span>
  );
}

export function isRecognitionGroup(groupId) {
  return groupId === "mdc_winner" || groupId === "pc_winner" || groupId === "sprint_to_pc";
}
